<!-- 

	Was macht diese Componente?
	Wofür ist die Compoente da?
	
	Welche $props gibt es?
	
	Beispiel Code:
		<MhModal :show="showTableModal" @close="showTableModal = false">
			<template slot="header">
				header
			</template>
			<template slot="body">
				body
			</template>
			<template slot="footer">
				footer
			</template>
		</MhModal>
	
	2020-08-08	refactor, vereinfacht
	2019-06-08	init

-->

<template>
	<div class="MhModal" :class="elmClasses">
		<div class="MhModal__background" @click="close()"></div>
		<div class="MhModal__inner">
			<div class="MhModal__header">
				<div class="MhModal__headerInner">
					<slot name="header"></slot>	
				</div>					
			</div>
			<div class="MhModal__body">
				<div class="MhModal__bodyInner">
					<slot name="body"></slot>
				</div>			
			</div>			
			<div class="MhModal__footer">
				<div class="MhModal__footerInner">
					<slot name="footer"></slot>
				</div>		
			</div>		
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import { EventBus } from '@/event-bus.js'
	import MhSpinner from '@/components/MhSpinner/MhSpinner.vue'

	export default {
		name: 'MhModal',
		components: {
			MhSpinner,
		},
		mixins: [],
		props: {
			show: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				isVisible : undefined,	
			}
		},
		watch: {
			'show': {
				handler: function( to, from ) {
					this.isVisible = to
					this.show = to
				},
				immediate: true,
			},
		},
		computed: {
			app() {
				return this.$root.$children[0]
			},
			elmClasses(){
				let classes = []
				
				if( this.isVisible ){
					classes.push('MhModal--isVisible')
				}else{
					classes.push('MhModal--isHidden')
				}
				
				return classes
			},
		},
		methods: {
			open(){
				this.isVisible = true
			},
			close(){
				this.isVisible = false
				this.$emit('close')
			},
		},
		created() {},
		mounted() {
			this.isVisible = this.show
		},
	}
</script>

<style lang="less">
	//@import "../../less/vars.less";
	//@import "../../less/mixins.less";
	//@import (reference) "../../less/atoms.less";
	
	.MhModal {
		position: fixed;
		top: 0; left: 0; right: 0; bottom: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 100;
		
		&--isHidden {
			opacity: 0;
			pointer-events: none;
		}
		&--isVisible {
			opacity: 1;
			pointer-events: auto;
		}
	}
	.MhModal__background {
		position: absolute;
		top: 0; left: 0; right: 0; bottom: 0;
		
		background-color: fade(black, 25);		
	}
	.MhModal__inner {
		position: relative;
		width: 90vw;
		//max-width: 850px;
		background-color: white;
		
		display: flex;
		flex-direction: column;
	}
</style>
